// Navigation utilities for role-based routing
import { getUser } from './auth';

/**
 * Get the home dashboard route for a user based on their role
 * This ensures superadmins always go back to superadmin dashboard
 * regardless of which dashboard they're currently viewing
 */
export const getHomeDashboardRoute = () => {
  const user = getUser();
  
  if (!user || !user.role) {
    console.warn('No user or role found, defaulting to /dashboard');
    return '/dashboard';
  }
  
  switch (user.role) {
    case 'superadmin':
      return '/superadmin-dashboard';
    case 'tenant_admin':
    case 'partner':
      return '/partner-dashboard';
    case 'student':
      return '/dashboard';
    default:
      console.warn(`Unknown role: ${user.role}, defaulting to /dashboard`);
      return '/dashboard';
  }
};

/**
 * Navigate to the user's home dashboard
 * Use this function instead of hardcoded navigation for "Home" buttons
 */
export const navigateToHomeDashboard = (navigate) => {
  const route = getHomeDashboardRoute();

  // Force navigation even if it's the same route to ensure proper rendering
  navigate(route, { replace: true });
};

/**
 * Check if the current user has permission to access a route
 */
export const canAccessRoute = (route) => {
  const user = getUser();
  
  if (!user) return false;
  
  // Superadmin can access everything
  if (user.role === 'superadmin') return true;
  
  // Tenant admin can access tenant admin routes
  if (user.role === 'tenant_admin' && (route.startsWith('/tenant') || route.startsWith('/settings/tenant'))) return true;
  
  // Partner can access partner routes
  if (user.role === 'partner' && route.startsWith('/partner')) return true;
  
  // Students can access student routes
  if (user.role === 'student' && (route === '/dashboard' || !route.includes('partner') && !route.includes('superadmin') && !route.includes('tenant/admin'))) return true;
  
  return false;
};